import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { LoadingButton } from "../../Utils/CustomComponent";
import { passwordRules, passwordReady } from "./passwordRules";

// New password + confirm with Oracle's rule list (docs/specs/password-reset-stepup.md). Shared by Forgot Password V2
// and Change Password V2. Calls onSubmit(password) only when every rule passes and both fields match.
const PasswordStep = ({ email, busy, error, onSubmit, submitLabel }) => {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const rules = passwordRules(password, email);
  const ready = passwordReady(password, confirm, email);

  const submit = (event) => {
    event.preventDefault();
    if (ready && !busy) onSubmit(password);
  };

  return (
    <form onSubmit={submit} noValidate>
      <Form.Group className="mb-3" controlId="pw-new">
        <Form.Label>New password</Form.Label>
        <Form.Control type="password" autoComplete="new-password" value={password}
          maxLength={128} onChange={(e) => setPassword(e.target.value)} autoFocus />
      </Form.Group>
      <Form.Group className="mb-2" controlId="pw-confirm">
        <Form.Label>Confirm new password</Form.Label>
        <Form.Control type="password" autoComplete="new-password" value={confirm}
          maxLength={128} onChange={(e) => setConfirm(e.target.value)} />
      </Form.Group>
      <ul className="list-unstyled small mb-3" aria-label="Password rules">
        {rules.map((rule) => (
          <li key={rule.id} className={rule.ok ? "text-success" : "text-muted"}>
            <span aria-hidden="true">{rule.ok ? "✓ " : "• "}</span>{rule.label}
          </li>
        ))}
        <li className={confirm && password === confirm ? "text-success" : "text-muted"}>
          <span aria-hidden="true">{confirm && password === confirm ? "✓ " : "• "}</span>Both passwords match
        </li>
      </ul>
      {error && <p className="text-danger" role="alert">{error}</p>}
      <LoadingButton type="submit" title={submitLabel} loading={busy} disabled={!ready || busy} className="w-100" />
    </form>
  );
};

export default PasswordStep;
